import { AccountMarketView, MarketView } from '@api-proxies';
import { MarketService } from '@http/clients/market.service';
import { MarketEntity } from './abstract/market-entity';

export class AccountMarketEntity extends MarketEntity<AccountMarketView> {
    constructor(marketService: MarketService) {
        super(marketService);
    }

    toDestination(entity: MarketView): AccountMarketView {
        return { marketId: entity.id, marketName: entity.name, accountId: 0, id: 0, accountName: undefined };
    }

    toSource(entity: AccountMarketView): MarketView {
        return { id: entity.marketId, name: entity.marketName };
    }
}
